<template>
  <div class="c-page u-relative">
    <section
      data-color="dark"
      class="u-relative u-fit-w u-bg--brand-dark u-overflow-h js-header-panel"
    >
      <div
        class="c-page__header o-wrapper--panel"
        :style="
          'transform:translateX(' +
          headerPageSize[2] +
          'px) translateY(' +
          headerPageSize[3] +
          'px) scale(' +
          headerPageSize[4] +
          ')'
        "
      >
        <img
          src="/static/HeadImages/trigercontracting-privacy-policy.jpg"
          class="u-absolute u-pos-tl"
          :style="
            'width:' +
            headerPageSize[0] +
            'px; height:' +
            headerPageSize[1] +
            'px'
          "
        />
      </div>
      <div class="o-wrapper--valign u-viewport-fit-h u-fit-w">
        <div
          class="
            u-relative u-inline-block
            c-top-maintitle
            u-pos-x-center u-align-center
          "
        >
          <span
            class="
              c-page__subtitle
              t-h1
              t-text-ls--md
              t-text--roman
              u-color--white
              u-align-center u-inline-block
            "
            v-html="content.subtitle"
          ></span>
          <h1
            class="
              t-h2-sub
              t-text-lh--md
              u-color--white
              u-align-center u-marg-b-lg
            "
          >
            <app-sliced-text :content="content.title"></app-sliced-text>
          </h1>
        </div>
      </div>
      <button v-scroll-to="'#start'"
        class="
          c-home__scroll-btn
          c-btn-scroll
          u-pos-x-center
          t-btn
          u-absolute u-inline-block u-marg-b-md@sm
        "
      >
        <img
          src="/static/common/MainLogoWhite -arrow-white2.svg"
          width="32px"
        />
      </button>
    </section>

    <section class="u-relative u-overflow-h u-fit-w js-header-panel">
      <a id="start">
      <div>
        <organization-chart :datasource="ds"></organization-chart>
      </div>
      </a>
    </section>
    <app-footer
      :globalContent="globalContent"
      :adminContent="adminContent"
    ></app-footer>
  </div>
</template>

  <script>
import AppFooter from "../app-footer/index.vue";
import AppScrollObject from "../app-scroll-object/index.vue";
import AppSlicedText from "../app-sliced-text/index.vue";
import AppRiskTools from "../app-sliced-text/index.vue";
import OrganizationChart from "vue-organization-chart";
import "vue-organization-chart/dist/orgchart.css";
export default {
  props: {
    debug: {
      type: Boolean,
      default: !1,
    },
    adminContent: {
      type: Object,
      default: function () {},
    },
    globalContent: {
      type: Object,
      default: function () {},
    },
    headerPageSize: {
      type: Array,
      default: function () {},
    },
  },
  components: {
    "app-footer": AppFooter,
    "app-scroll-object": AppScrollObject,
    OrganizationChart,
    "app-sliced-text": AppSlicedText,
    "app-risk-tools": AppRiskTools,
  },
  computed: {
    content: function () {
      return this.adminContent.en.pages.organizationalstructure;
    },
    myStylesTransform2() {
      return {
        transform:
          "translateX(" +
          this.headerPageSize[2] +
          "px) translateY(" +
          this.headerPageSize[3] +
          "px) scale(" +
          this.headerPageSize[4] +
          ")",
      };
    },
    myStylesWidthHeight() {
      return {
        width: this.headerPageSize[0] + "px",
        height: this.headerPageSize[1] + "px",
      };
    },
    myStylesWidthHeight11() {
      return {
        width: "1600px",
        height: "900px",
      };
    },
  },
  created: function () {
    this.eventHub.$on("resize", this.onResize);
  },
  destroyed: function () {
    this.eventHub.$off("resize", this.onResize);
  },
  mounted: function () {
    this.onResize(), this.eventHub.$emit("page:ready");
  },
  data: function () {
    return {
      ds: {
        id: "1",
        name: "Mr. Mohamed Yousef Al Mana",
        title: "Managing Director",
        children: [
          { id: "2", name: "Sister", title: "Companies" },

          {
            id: "3",
            name: "Mr. Bahij El Helou",
            title: "General Manager",
            children: [
              
              {
                id: "6",
                name: "Safety",
                title: "Department",
                children: [
                  {
                    id: "7",
                    name: "Safety Officer",
                    title: "2 Nos",
                    children: [
                      { id: "8", name: "Asst. Safety Officer", title: "2 Nos" },
                    ],
                  },
                ],
              },
              {
                id: "9",
                name: "QA/QC",
                title: "Department",
                children: [
                  {
                    id: "10",
                    name: "QA/QC Engineer",
                    title: "1 Nos",
                    children: [
                      {
                        id: "11",
                        name: "Technician",
                        title: "1 Nos",
                        children: [
                          {
                            id: "12",
                            name: "Asst. Technician",
                            title: "2 Nos",
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                id: "13",
                name: "Administration",
                title: "Department",
                children: [
                  {
                    id: "14",
                    name: "Administrator",
                    title: "1 Nos",
                    children: [{ id: "15", name: "Secretary", title: "1 Nos" }],
                  },
                ],
              },
              {
                id: "16",
                name: "Procurement",
                title: "Department",
                children: [
                  {
                    id: "17",
                    name: "Procurement Officer",
                    title: "1 Nos",
                    children: [
                      { id: "18", name: "Store Keepers", title: "2 Nos" },
                    ],
                  },
                ],
              },
              {
                id: "5",
                name: "Projects",
                title: "Manager",
                children: [
                  {
                    id: "21",
                    name: "Project / Site",
                    title: "Engineers 4 Nos",
                    children: [
                      {
                        id: "22",
                        name: "Surveyor",
                        title: "1 Nos",
                        children: [
                          {
                            id: "23",
                            name: "Supervisors",
                            title: "4 Nos",
                          },
                          {
                            id: "24",
                            name: "Foremen",
                            title: "10 Nos",
                          },
                          {
                            id: "25",
                            name: "Work Force",
                            title: "226 Nos",
                          }
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                id: "19",
                name: "Accounts",
                title: "Department",
                children: [{ id: "20", name: "Accountant", title: "2 Nos" }],
              },
              
              {
                id: "26",
                name: "Estimator/QS",
                title: "Department",
                children: [
                  {
                    id: "27",
                    name: "Estimator",
                    title: "1 Nos",
                    children: [
                      { id: "28", name: "Quantity Surveyor", title: "2 Nos" },
                    ],
                  },
                ],
              },
              {
                id: "29",
                name: "Technical",
                title: "Department",
                children: [
                  {
                    id: "30",
                    name: "Technical Engineers",
                    title: "1 Nos",
                    children: [
                      { id: "31", name: "Draftsmen", title: "2 Nos" },
                    ],
                  },
                ],
              },
              {
                id: "32",
                name: "Planning",
                title: "Department",
                children: [
                  {
                    id: "33",
                    name: "Planning",
                    title: "Engineer"
                  },
                ],
              }
            ],
          },
          { id: "4", name: "Contracts", title: "Department" },
        ],
      },
    };
  },
  methods: {
    onResize: function () {},
  },
};
</script>
